import * as React from 'react';
import Chart from '../../../components/company_operations/time-admin/Chart';
import axios from 'axios';
import CollapsibleArea from '../../../components/common/CollapsibleArea';
import AxiosConfig from '../../../utilities/AxiosConfig';
import CategoryChart from '../../../components/company_operations/time-admin/CategoryChart';
import { DepartmentReferenceType, DLSListItem, PermissionType, TimeEntryType } from './types';
import Loader from '../../../components/common/Loader';
import dayjs from 'dayjs';
import ActionButtons from '../../../components/company_operations/time-admin/ActionButtons';
import TimeDisplay from '../../../components/company_operations/time-admin/TimeDisplay';
import TicketGap from '../../../components/company_operations/time-admin/TicketGap';
import { Accordion, Card, Modal, OverlayTrigger, Table, Tooltip as BSTooltip } from 'react-bootstrap';
import makeDraggable from '../../../utilities/draggableDiv';
import Checkbox from '../../../components/common/checkbox/index';
import TicketTextBox from 'src/components/common/TicketTextBox';
import MsalAuth from '../../../utilities/msalAuth';
import UserSettings from '../../../utilities/UserSettings'
import Tooltip from 'src/components/common/Dynamic-old/Tooltip';
import { getTicketDetails } from '../DailyReview/TimeAdminTicketDetail/TimeAdminTicketDetail';
import TicketDetail from '../../../components/company_operations/ticket-search/Details';
import './Details.css';
import { AppState } from 'src/store';
import { connect } from 'react-redux';
import snackBar from 'src/utilities/snackBar/SnackBar';
import DLSMap from 'src/components/company_operations/time-admin/DLSMap';

export interface IProps {
    details: any;
    handleClose: any;
    profitCenter: number | null;
    unselectRow: any;
    reference: any;
    refresh: any;
    profitCenterName: string | null;
    parent?: string;
    userid?: string;
}

const Details: React.FC<IProps> = ({ details, handleClose, profitCenter, unselectRow, reference, refresh, profitCenterName, parent, userid }: IProps) => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState(null as any);
    const [categoryData, setCategoryData] = React.useState([] as any);
    const [mapDetails, setMapDetails] = React.useState(null as null | DLSListItem);
    const [permissions, setPermissions] = React.useState(null as PermissionType | null);
    const [activeId, setActiveId] = React.useState('0' as string | null);
    const [ticketText, setTicketText] = React.useState("Fetching ticket text");//?
    const [showModal, setShowModal] = React.useState(false);
    const [clickTicketShowModal, setClickTicketTextShowModal] = React.useState(false);
    const [categoryChartReady, setCategoryChartReady] = React.useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [showDLSPopover, setShowDLSPopover] = React.useState(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [dLSPopoverContent, setDLSPopoverContent] = React.useState("");
    //r-18-lint-cm
    //eslint-disable-next-line
    const [mapDls, setMapDls] = React.useState(null as null | DLSListItem | Number);
    const [showTicketText, setShowTicketText] = React.useState(false);
    const [ticketNumber, setTicketNumber] = React.useState(0);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [userSettings, setUserSettings] = React.useState(MsalAuth.UserSettings() || {});
    const [savedTicketText, setSavedTicketText] = React.useState([{
        ticketId: Number,
        ticketText: ticketText
    }]);
    const [entryToDelete, setEntryToDelete] = React.useState<any>();

    const getTimeDetails = async () => {
        setLoading(true);
        try {
            const res = await axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/timedetail/${details.employeeId}/${profitCenter}/${details.date}`, AxiosConfig.configValue("min"))
            if (AxiosConfig.checkResponse(res)) {
                setData(res.data.detail);
                if (res.data.detail.dlsList) {
                    setMapDetails(res.data.detail.dlsList[0])
                }
            }
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    const refreshEmployee = () => {
        refresh(details.employeeId, profitCenter);
    }

    const renderCategories = () => {
        //? NEW LOGIC
        //? Split out into departments
        //? In each department display time entry codes and associated totals
        //? Departments display horizontally and time entries are vertical
        let departments: any = {
            // DEPTID: [...entries]
        }
        let departmentId: any = reference?.departments.find((dept: DepartmentReferenceType) => {
            return dept.Description === profitCenterName;
        })?.DepartmentId;
        details.entries.forEach((entry: any) => {
            if (!departments[entry.DepartmentId]) { departments[entry.DepartmentId] = []; }
            departments[entry.DepartmentId].push(entry);
        });
        // console.log("User Departments Permission", permissions)


        //!!*******************************************************************************************************
        //!!! refer to bug 2611 in the future (ben kile)
        // const userDepartment = permissions?.departments[0].DepartmentId;//!!this made the assumption that length was > 0
        const userDepartment = (permissions && permissions.departments.length > 0) ? permissions.departments[0].DepartmentId : null
        //!!*******************************************************************************************************

        //r-18-lint-cm
        //eslint-disable-next-line
        const departmentEntries = (Object.entries(departments));
        //console.log("Final Departments", departments, userDepartment);
        if (Object.entries(departments).length === 0) {
            return (
                permissions?.canEditTime
                    ?
                    <ActionButtons
                        employeeId={details.employeeId}
                        refreshEmployee={refreshEmployee}
                        date={details.date}
                        allowedDepartments={permissions?.departments || []}
                        departments={departments}
                        departmentName={profitCenter}
                        showAdd
                        inUsePC={profitCenter}
                    />
                    : null
            )
        }
        if (departmentId && !departments[departmentId]) {
            departments[departmentId] = [];
        }
        let totalHours: number = 0;
        Object.keys(departments).forEach((deptKey: string) => {
            departments[deptKey].forEach((timeEntry: any) => { totalHours += timeEntry.Quantity });
        })
        //console.log("Total Hours: ", totalHours);
        // @ts-ignore
        window.TimeAdminDetailTotal = totalHours;

        return (
            //cgm sorting the department keys based on whether it's the user's department first             
            Object.keys(departments).sort((a, b) => {
                if (Number(a) === userDepartment) {
                    return -1
                } else if (Number(b) === userDepartment) {
                    return 1
                } else {
                    return 0
                }
            })
                .map((key: string) => {
                    const referenceValue: any = reference.departments.find((dept: DepartmentReferenceType) => dept.DepartmentId === Number(key));
                    //console.log("REFERENCE VALUE: ", referenceValue, profitCenter);
                    return (
                        <div key={key} className='time-admin-timesheet-department-hours-container'>
                            <div className='time-admin-timesheet-department-hours-header-wrapper'>
                                <div className='time-admin-timesheet-department-hours-header-title'>
                                    {referenceValue?.DisplayName || key}
                                </div>
                                {
                                    departments[key]?.length
                                        ?
                                        departments[key][0].IsApproved && (
                                            <div className='time-admin-timesheet-label'>
                                                Approved by {departments[key][0].ApprovedByUserName} on {dayjs(departments[key][0].ApprovedDate).format("MM-DD-YYYY")}
                                            </div>
                                        ) : null
                                }
                                <div>
                                    {
                                        (permissions?.canEditTime
                                            && permissions?.departments.findIndex((dept: DepartmentReferenceType) => dept.DepartmentId === Number(key)) !== -1)
                                            ?
                                            <ActionButtons
                                                employeeId={details.employeeId}
                                                refreshEmployee={refreshEmployee}
                                                date={details.date}
                                                allowedDepartments={permissions?.departments}
                                                departments={departments}
                                                departmentName={key}
                                                inUsePC={profitCenter}
                                            />
                                            : null
                                    }
                                    {
                                        ((permissions?.canEditTime
                                            && permissions?.departments.findIndex((dept: DepartmentReferenceType) => dept.DepartmentId === Number(key)) !== -1)
                                            && (departments[key].length === 0 && Number(key) === departmentId)
                                        )
                                            ?
                                            <ActionButtons
                                                employeeId={details.employeeId}
                                                refreshEmployee={refreshEmployee}
                                                date={details.date}
                                                allowedDepartments={permissions?.departments}
                                                departments={departments}
                                                departmentName={key}
                                                showAddDefault
                                                inUsePC={profitCenter}
                                            />
                                            : null
                                    }
                                </div>
                            </div>
                            <div className='time-admin-timesheet-hours-wrapper'>
                                {departments[key]?.map((entry: TimeEntryType) =>
                                    <TimeDisplay
                                        employeeId={details.employeeId}
                                        refreshEmployee={refreshEmployee}
                                        key={entry.TimeEntryId}
                                        entry={entry}
                                        departmentId={key}
                                        allowedDepartments={permissions?.departments}
                                        canEdit={permissions?.canEditTime}
                                        inUsePC={profitCenter}
                                        entryToDelete={entryToDelete}
                                        setEntryToDelete={setEntryToDelete}
                                    />
                                )}
                            </div>
                        </div>)
                }
                )
        )
    }

    const handleDlsClick = (e: React.MouseEvent, item: DLSListItem) => {
        e.preventDefault();
        e.stopPropagation();
        setMapDetails(item);
    }

    const handleCloseDetail = (e: React.MouseEvent) => {
        e.preventDefault();
        handleClose();
        unselectRow();
    }

    const checkPermissions = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/timeentrypermission/${profitCenter}`, AxiosConfig.configValue("min"))
            const { CanViewTime, canEditTime, departments } = res.data;
            setPermissions({ CanViewTime, canEditTime, departments });
        } catch (error) {
            console.error(error)
        }
    }

    React.useEffect(() => {
        const run = async () => {
            setCategoryChartReady(false);
            //cgm 031622 if showTicketText is set in UserSettings then set show ticket text in state
            if (userSettings.showTicketText) {
                setShowTicketText(userSettings.showTicketText)
            } // end of userSettings state checker
            //console.log("Details: ", details);
            let categories: any = {};
            details.entries.forEach((entry: any) => {
                if (!categories[entry.Category]) { categories[entry.Category] = entry.Quantity }
                else { categories[entry.Category] += entry.Quantity }
            });
            setCategoryData(Object.keys(categories).map((category: string) => ({
                name: category,
                y: categories[category],
                selected: false
            })));
            await getTimeDetails();
            await checkPermissions();
            setCategoryChartReady(true)
        }
        run()
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [details])

    // custom toggle for accordion for DLS List
    const toggleActive = (cardId: string) => {
        if (activeId === cardId) {
            setActiveId(null);
        } else {
            setActiveId(cardId);
        }
    }

    // cgm 030922 ******* DLS TICKET TEXT ********
    //cgm getTicketText and showDLSModal for the tickets showing on hover on the DLS List
    const getTicketText = (e: React.MouseEvent, ticketId: any) => {
        e.stopPropagation();
        e.preventDefault();
        ifTicketAlreadyAdded(savedTicketText, ticketId) ?
            setTicketText(ticketFromSaved(savedTicketText, ticketId))
            :
            setTicketText("Fetching ticket text")//?
        axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/tickettext/${ticketId}`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                setTicketText(res.data);
                generateTicketTextArray(ticketId, res.data);
                //console.log("Saved TicketText", savedTicketText)
            })
            .catch((err: any) => {
                //console.log("Error from Ticket Text:", err, err.response)
            })
    }
    //cgm 031622 for checking if Ticket has been added to the current state array
    const ifTicketAlreadyAdded = (arr: any, item: any) => {
        const found = arr.some((el: any) => el.ticketId === item);
        if (found) { return true }
    }
    //cgm 031622 Pulling a saved ticket from the saved TicketText array
    const ticketFromSaved = (arr: any, item: any) => {
        const result = arr.filter((ticket: any) => ticket.ticketId === item).map((foundTicket: any) => foundTicket.ticketText);
        return (result);
    }
    //cgm 031622 Logging to console if the ticket is in the array or adding it to the TicketText array
    const generateTicketTextArray = (ticketId: NumberConstructor, ticketText: string) => {
        // ifTicketAlreadyAdded(savedTicketText, ticketId) ?
        //     //console.log("TicketText previously added") :
        //     setSavedTicketText([...savedTicketText, { ticketId, ticketText }])
        // ifTicketAlreadyAdded(savedTicketText, ticketId) ?
        //     console.log("TicketText previously added") :
        //     setSavedTicketText([...savedTicketText, { ticketId, ticketText }])
        //??r-18-test-bk
        if (!ifTicketAlreadyAdded(savedTicketText, ticketId)) {
            setSavedTicketText([...savedTicketText, { ticketId, ticketText }])
        }
    }

    const hoverTicketText = (e: React.MouseEvent, ticketId: any) => {
        e.stopPropagation();
        e.preventDefault();
        setTicketText("Fetching ticket text")
        setShowModal(!showModal)
        getTicketText(e, ticketId);
    }

    // cgm030922 --> button for enabling ticket text on hover
    const handleShowTicketTextClick = () => {
        setShowTicketText(!showTicketText);
        //setting show ticket text button to memorize the state per user
        let settings = userSettings
        settings.showTicketText = !showTicketText
        UserSettings.update(settings)
        //console.log(settings)
    }

    const [ticketDetails, setTicketDetails] = React.useState<any>();
    const [showTicketDetailModal, setShowTicketDetailModal] = React.useState(false);
    // cgm030922 --> cancel out any on hover text modal so it doesn't show when you close the ticket resizeable div
    const handleTicketClick = async (e: React.MouseEvent, ticketId: any) => {
        // getTicketText(e, ticketId)
        setClickTicketTextShowModal(!clickTicketShowModal);
        // setShowModal(false);

        const response = await getTicketDetails(ticketId);
        if (!response.success) {
            snackBar({ text: 'There was an error getting ticket details. Please try again.', type: 'error', timeout: 4000 });
            return
        }
        setTicketDetails(response.response);
        setShowTicketDetailModal(true);
    }

    const showDLSModal = () => {
        return (
            <Modal id="dls-info-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                className='cursor-on-hover'
                // currently you can leave via moving mouse off of the modal or clicking the button
                onMouseLeave={handleCloseDlsModal}
            >
                <Modal.Body style={{ textAlign: 'left' }}>
                    <button className="action-text-danger material-icons"
                        style={{ position: 'absolute', top: 5, right: 5, padding: 0, zIndex: 25, overflowWrap: 'normal' }}
                        onClick={handleCloseDlsModal}
                    >close</button>
                    <pre className='ticket-text'>{ticketText}</pre>
                </Modal.Body>
            </Modal>
        )
    }

    const showDlsTicketText = () => {
        return (
            <TicketTextBox ticketText={ticketText} showText={clickTicketShowModal} setShowText={setClickTicketTextShowModal} ticketNumber={ticketNumber} />
        )
    }

    const handleCloseDlsModal = () => {
        setShowModal(!showModal)
    }

    const commentExpander = (index: number) => {
        let comment = document.getElementById(`comment-cell-${index}`);
        comment?.classList.remove('text-truncate');
        //console.log(comment?.id)
    }

    const commentShrinker = (index: number) => {
        let comment = document.getElementById(`comment-cell-${index}`);
        comment?.classList.add('text-truncate');
    }

    return (
        <div>
            <CollapsibleArea Toggle={(p: any) => {
                return (<div {...p} className="d-flex align-items-center flex-row cursor-on-hover pb-2 ticket-search-header" style={{ marginBottom: 20 }}>
                    <h5 className="d-flex align-items-center"><i className="material-icons">schedule</i>Timesheet</h5>
                    {parent != 'DailyReview' && (<><h5 style={{ marginLeft: 40 }}>{details.employee}</h5>
                        <h5 style={{ marginLeft: 40 }}>{dayjs(details.date).format("dddd MM/DD/YYYY")}</h5>
                        <h5 style={{ marginLeft: 40 }}>Production: {data && data.productionPercent} </h5></>)}
                    <i className="material-icons text-secondary ml-auto" style={{ fontSize: "1.5rem" }}>{p.open ? "expand_less" : "expand_more"}</i>
                    <button className="action-text-danger material-icons" onClick={handleCloseDetail}>close</button>
                </div>)
            }} startOpen>
                <div className='time-admin-timesheet-container'>
                    {permissions ? (
                        <div className='time-admin-timesheet-hours-container'>
                            {renderCategories()}
                        </div>
                    ) : null}
                    <div className='time-admin-timesheet-chart-container'>
                        {categoryChartReady ? (
                            <CategoryChart data={categoryData} dlsList={data?.dlsList || []} />
                        ) : (
                            <div style={{ height: 210, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Loader title="Loading chart..." />
                            </div>
                        )}
                    </div>
                </div>
            </CollapsibleArea>
            <CollapsibleArea Toggle={(p: any) => {
                return (<div {...p} className="d-flex align-items-center flex-row cursor-on-hover pb-2 ticket-search-header" style={{ marginBottom: 20 }}>
                    <h5 className="d-flex align-items-center"><i className="material-icons">analytics</i>Analysis</h5>
                    <i className="material-icons text-secondary ml-auto" style={{ fontSize: "1.5rem" }}>{p.open ? "expand_less" : "expand_more"}</i>
                </div>)
            }} startOpen>
                <div style={{ minHeight: 300 }} className='time-admin-analysis-container'>
                    {
                        loading
                            ?
                            <div className="w-100 d-flex justify-content-center align-items-center time-admin-analysis-loader-container" style={{ height: 400 }}>
                                <Loader title="Loading Data..." />
                            </div>
                            : <>
                                <div className='time-admin-analysis-chart-container'>
                                    {data !== null && <Chart date={details.date} data={data?.intervals || []} />}
                                </div>
                                <div className="time-admin-analysis-dls-container">
                                    <div className='time-admin-analysis-dls-header-container'>
                                        <div className='time-admin-analysis-dls-label'>DLS List:</div>
                                        {/* <div>
                                            <Checkbox isChecked={showTicketText} onChange={handleShowTicketTextClick} label='Show Ticket Text' />
                                        </div> */}
                                        <div className='time-admin-analysis-dls-info-wrapper'>
                                            <Tooltip name="TT-DLS-List" placement="left" />
                                        </div>
                                    </div>
                                    <hr style={{ height: 2 }} className="w-100 text-secondary mt-0" color="lightgrey" />
                                    {/*cgm for displaying ticket text on hover for the DLS list */}
                                    {(showModal && !clickTicketShowModal) && showDLSModal()}
                                    {/* {clickTicketShowModal && showDlsTicketText()}                                     */}
                                    {clickTicketShowModal && ticketDetails && (
                                        <Modal id="ticket-detail-modal"
                                            show={showTicketDetailModal}
                                            backdrop="static"
                                            centered={true}
                                            size='lg'
                                        >
                                            <Modal.Body>
                                                <TicketDetail
                                                    handleClose={() => { setShowTicketDetailModal(false); setTicketDetails(null); setClickTicketTextShowModal(false) }}
                                                    details={ticketDetails}
                                                    userId={userid !== undefined ? Number(userid) : undefined}
                                                    isVertical={false}
                                                    toggleVertical={() => { }}
                                                />
                                            </Modal.Body>
                                        </Modal>
                                    )}
                                    {
                                        (data !== null && data.dlsList) ? data.dlsList.map((item: DLSListItem, index: number) =>
                                            <div className='dlsItem' key={`${index}`} >
                                                <Accordion className='dlsListCard' defaultActiveKey={`${index}`}>
                                                    <Card className='dlsListPanel'>
                                                        <Card.Header className='cardHeader'>
                                                            <Accordion.Toggle className='accordionToggle' as={Card.Header} eventKey={`${index}`} onClick={() => toggleActive('0')}  >
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h5 key={item.dlsid}
                                                                        onClick={(e: React.MouseEvent) => handleDlsClick(e, item)}
                                                                    >
                                                                        DLSID: {item.dlsid}
                                                                    </h5>
                                                                    <div className="d-flex align-items-center">
                                                                        <h5>{item.ticketCount} {item.ticketCount > 1 ? "Tickets" : "Ticket"}</h5>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Toggle>
                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey={`${index}`}>
                                                            <div className='time-admin-analysis-dls-table-scroll-wrapper'>
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='ticket-number-label'>Ticket Number</th>
                                                                        <th>Start</th>
                                                                        <th>End</th>
                                                                        <th>Comments</th>
                                                                        <th className='status-label'>Status</th>
                                                                        <th>Responses{' '}
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={
                                                                                    <BSTooltip id="system-response-tooltip">
                                                                                        System Responses apply special, Customer-specific logic to entered Locator Responses. This may result in differences in ResponseQty and Footage between the two. Any Revenue displayed is taken from System Responses when available.
                                                                                    </BSTooltip>
                                                                                }
                                                                            >
                                                                                <i className="material-icons time-admin-analysis-dls-response-info-icon">info</i>
                                                                            </OverlayTrigger>
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                {/*!!r-18-dj*/}
                                                                {/*@ts-ignore*/}
                                                                <tbody>
                                                                    {/* {item.ticketList.filter(ticketItem => (ticketItem. ))} */}
                                                                    {item.ticketList.map((ticket: any, ticketIndex: number) =>
                                                                        <tr className='dlsList-row' key={`${ticket.ticketNumber}-${ticketIndex}`}>
                                                                            {
                                                                                // checking if either array has any items.  If they are empty then it's a duplicate and we don't want to render it.
                                                                                (ticket.startTimeList.length > 0 || ticket.endTimeList.length > 0) &&
                                                                                    // cgm(3/9/22) --> only enable hover changes if ticket hasn't been clicked to keep it from being changed
                                                                                    showTicketText && !clickTicketShowModal ?
                                                                                    //!!r-18-dj
                                                                                    //@ts-ignore
                                                                                    <td className='ticket-number-cell'
                                                                                        onMouseDown={(e) => { handleTicketClick(e, ticket.ticketId) }}
                                                                                    >
                                                                                        {
                                                                                            showTicketText ?
                                                                                                <span style={{ color: 'blue', textDecoration: 'underline' }} onMouseEnter={(e) => setTicketNumber(ticket.ticketNumber)}>
                                                                                                    {ticket.ticketNumber}
                                                                                                </span> :
                                                                                                <span>
                                                                                                    {ticket.ticketNumber}
                                                                                                </span>
                                                                                        }
                                                                                    </td> :
                                                                                    <td className='ticket-number-cell' >
                                                                                        <span className='time-admin-analysis-dls-clickable-cell' onMouseDown={(e) => {
                                                                                            handleTicketClick(e, ticket.ticketId);
                                                                                            setTicketNumber(ticket.ticketNumber);
                                                                                        }}  >
                                                                                            {ticket.ticketNumber}
                                                                                        </span>
                                                                                    </td>
                                                                            }
                                                                            <td>{ticket.startTimeList.map((time: any, index: number) => {
                                                                                return (<p key={index}>{time}</p>)
                                                                            })}</td>
                                                                            <td>{ticket.endTimeList.map((time: any, index: number) => {
                                                                                return (<p key={index}>{time}</p>)
                                                                            })}</td>
                                                                            <td id={`comment-cell-${index}`} className='comment-text text-truncate' onMouseEnter={() => commentExpander(index)} onMouseLeave={() => commentShrinker(index)} >
                                                                                {ticket.comments}
                                                                            </td>
                                                                            <td className='status-cell'>
                                                                                {ticket.status}
                                                                            </td>
                                                                            <td>
                                                                                {(!ticket.responses || ticket.responses.length === 0) ? (
                                                                                    <span>No Responses</span>
                                                                                ) : (
                                                                                    <Table size='sm' bordered striped>
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Billing Response</th>
                                                                                                <th>PR</th>
                                                                                                <th>Member Code</th>
                                                                                                <th>System Response</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {ticket.responses && ticket.responses.map((response: any, responseIndex: number) => (
                                                                                                <tr key={`${ticket.ticketNumber}-${ticketIndex}-${responseIndex}`}>
                                                                                                    <td>{`${response.UtilityAbbreviation}: ${response.ResponseQty}${response.ResponseCode}${response.Feet} ft`}</td>
                                                                                                    <td>{response.PositiveResponseCode}</td>
                                                                                                    <td>{response.MemberCode}</td>
                                                                                                    {response.IsSystem && (
                                                                                                        <td>
                                                                                                            <span className="material-icons-outlined time-admin-analysis-dls-response-icon-yes">check</span>
                                                                                                        </td>
                                                                                                    )}
                                                                                                    {!response.IsSystem && (
                                                                                                        <td>
                                                                                                            <span className="material-icons-outlined time-admin-analysis-dls-response-icon-no">close_small</span>
                                                                                                        </td>
                                                                                                    )}
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </Table>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                            </div>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </div>
                                        )
                                            : <span>No DLS Entries</span>
                                    }
                                </div>
                                {/* <div className="d-flex flex-column col-sm-8 col-lg-4 border">
                                </div> */}
                                <div style={{ minHeight: 300, overflowX: 'scroll' }} className="time-admin-analysis-ticket-time-gaps-container">
                                    <TicketGap dlsList={data?.dlsList} mapDls={mapDetails?.dlsid} setMapDls={setMapDls} />
                                </div>
                                <div className="time-admin-analysis-dls-map-container" style={{ height: 400, overflow: 'hidden', padding: '0.5rem' }}>
                                    <DLSMap mapDetails={mapDetails} />
                                </div>
                            </>
                    }
                </div>
            </CollapsibleArea>
        </div>
    );
}

const mapStateToProps = (state: AppState) => ({
    userid: state.user.userId
})

export default connect(mapStateToProps)(Details);